const SKILLS = [
  'JavaScript',
  'TypeScript',
  'React.js',
  'Next.js',
  'CSS',
  'html',
  'Tailwind',
  'Node.js',
  'Express.js',
  'Java',
  'SQL',
  'MongoDB',
  'Machine Learning',
  'Firebase',
  'Linux',
  'wordPress',
  'Git',
  'Teamwork',
];

const PROJECTS = [

  {
    id: 0,
    title: 'Hard-Drive-Prediction',
    subtitle:
      'A predictive app using machine learning to anticipate hard drive failures, safeguarding data integrity and minimizing downtime risks. ',
    stack: ['Python', 'Machine Learning', 'Google Colab', 'Github', 'Html'],
    github: 'https://github.com/HarshikaAdarsh/Hard-Drive-Failure-Prediciton',
   // link: 'https://',
  },
   {
    id: 1,
    title: 'E-Commerce',
    subtitle:
      'Designed and developed a dynamic ecommerce platform using MERN stack, integrating seamless user experience with robust backend functionalities, ensuring secure transactions and efficient product management. ',
    stack: ['React.js', 'Express.js', 'Nodejs', 'Mysql'],
    github: 'https://github.com/HarshikaAdarsh/E-commerce',
   // link: 'https://',
  },
   {
    id: 2,
    title: 'Agro-Tech',
    subtitle:
      'This unique online Agriculture webapp allows farmer to sell their product in reasonable price also helps buyers to buy product directly from farmers fields. ',
    stack: ['html', 'css', 'Js', 'Nodejs', 'Mysql'],
    github: 'https://github.com/HarshikaAdarsh/Agriculture-tech',
   // link: 'https://',
  },
  {
    id: 3,
    title: 'Portfolio ',
    subtitle:      'This is my portfolio developed using React Js and deployed on github pages. It coverd all of my projects (links attached), and the technologies on which they were developed are displayed as well.',
    stack: ['React', 'git', 'github', 'github page'],
    github: 'https://github.com/HarshikaAdarsh/portf',
   // link: 'https://vivercel.p',
  },
  {
    id: 4,
    title: 'DiscussIon',
    subtitle:
      'React-based Online News Portal allows both admins and users to read, add, and modify news seamlessly. Empowering users with easy access to current events and enabling administrators to manage content effortlessly.',
    stack: ['React', 'Node js', 'Express js', 'MongoDB'],
    github: 'https://github.com/HarshikaAdarsh/DiscussIon',
   // link: 'https://dvercel.app/',
  },
  {
    id: 5,
    title: 'BOOKNOOK',
    subtitle:
      'React-powered Online Room Booking System facilitates seamless admin control for data management (add, update, delete) and user-friendly room exploration and booking. Streamlined interface for efficient room reservations. ',
    stack: ['React.js', 'Node js', 'Express js', 'MongoDB'],
    github: 'https://github.com/HarshikaAdarsh/BookNook',
   // link: 'https://vercel.app/',
  },
  {
    id: 6,
    title: 'Multiple Disease Detection ',
    subtitle:
      'Developed a Disease Prediction System that amalgamates the fields of Medicine and technology. It can predict Parkinson’s, heart diseases, diabetes, and various other diseases based on inputs such as age, blood pressure, and various other diseasespecific inputs.',
    stack: ['Python','Machine Learning', 'Streamlit', 'Kaggle', 'Jupiter'],
    github: 'https://github.com/HarshikaAdarsh/ml-webapp',
   // link: 'https://github.com',
  },
  {
    id: 7,
    title: '3D Portfolio',
    subtitle:
      'Crafted a captivating 3D portfolio using ReactJS and Three.js, enhancing user engagement with immersive graphics and animations. Credit to JavaScript Mastery channel for Threejs beginners video ',
    stack: ['React.js', 'Three.js'],
    github: 'https://github.com/HarshikaAdarsh/motionPortfolio',
   // link: 'https://vercel.app/',
  },
  {
    id: 8,
    title: 'Plant Disease Detection',
    subtitle:
      'Developed a Web Application that uses convolutional neural network (CNN) method of deep learning. It can detect stages of disease of plant, and the appropriate treatment it needs through images. ',
    stack: ['Python', 'Deep Learning', 'Streamlit', 'Kaggle'],
    github: 'https://github.com/HarshikaAdarsh/ML_Plant_App',
//link: 'https://github.com',
  },
  {
    id: 7,
    title: 'Project',
    subtitle:
      'Coming Soon .',
    stack: ['React.js', 'Express.js', 'MongoDB'],
    github: 'https://github.com',
  //  link: 'https://mov',
  },
  {
    id: 8,
    title: 'Project',
    subtitle:
      'Coming Soon.',
    stack: ['React.js', 'Express.js', 'MongoDB'],
    github: 'https://github.com',
  //  link: 'https://',
  },
  {
    id: 9,
    title: 'Project',
    subtitle:
      'Coming Soon.',
    stack: ['JavaScript', 'CSS'],
    github: 'https://github.com',
//link: 'https://',
  },
  {
    id: 10,
    title: 'Project',
    subtitle:
      'Coming Soon.',
    stack: ['React.js', 'CSS'],
    github: 'https://github.com',
  //  link: 'https://',
  },
  {
    id: 11,
    title: 'Project',
    subtitle:
      'Coming Soon.',
    stack: ['React js',],
    github: 'https://github.com',
  //  link: 'https://github.c',
  },
  {
    id: 12,
    title: 'Project',
    subtitle:
      'Coming Soon.',
    stack: ['React.js', 'CSS'],
    github: 'https://github.',
    link: 'https://a',
  },
  {
    id: 13,
    title: 'Project',
    subtitle:
      'Coming Soon.',
    stack: ['HTML', 'CSS', 'JavaScript'],
    github: 'https://',
    link: 'https://',
  },
  {
    id: 14,
    title: 'Project',
    subtitle:
      'Coming Soon.',
    stack: ['HTML', 'CSS', 'JavaScript'],
    github: 'https:/',
    link: 'https:/',
  },
  {
    id: 15,
    title: 'Project',
    subtitle:
      '',
    stack: ['HTML', 'CSS', 'Javascript', 'BEM'],
    github: 'http',
    link: 'https:/n',
  },
  {
    id: 16,
    title: 'Project',
    subtitle:
      '',
    stack: ['React.js', 'CSS', 'styled-components'],
    github: 'https://',
    link: 'https://',
  },
  {
    id: 17,
    title: 'Project',
    subtitle: '',
    stack: ['React.js', 'CSS'],
    github: 'https://github.com',
    link: 'https://github.com',
  },

  {
    id: 18,
    title: 'Project',
    subtitle:
      '',
    stack: ['Vue.js', 'CSS', 'REST API'],
    github: 'https://github.com',
    link: 'https://',
  },
  {
    id: 19,
    title: 'Project',
    subtitle:
      '',
    stack: ['Python', 'Pygame', 'Tiled'],
    github: 'https://github.com',
    link: 'https://github.com',
  },
  {
    id: 20,
    title: 'Project',
    subtitle:
      '',
    stack: ['Python', 'Pygame', 'Tiled'],
    github: 'https://github.com',
    link: 'https://github.com',
  },
  {
    id: 21,
    title: 'Project',
    subtitle:
      '',
    stack: ['Python', 'Pygame'],
    github: 'https://github.com',
    link: 'https://github.com',
  },
];

const CARD_COUNT = {
  SMALL_DEVICE: {
    ADD: 3,
    START: 3,
  },
  MIDDLE_DEVICE: {
    ADD: 2,
    START: 4,
  },
  BIG_DEVICE: {
    ADD: 3,
    START: 6,
  },
};

const CARD_BREAKPOINT = {
  TWO: 1000,
  ONE: 700,
};

export { CARD_BREAKPOINT, CARD_COUNT, PROJECTS, SKILLS };
